import { PracticeView } from "@/shared/modules/typescript-trustapi-client/models/practice-view";
import { Module } from "vuex";

const practiceStoreModule: Module<any, any> = {
  state: {
    selectedPractice: {},
  },
  mutations: {
    setSelectedPractice(state, i: PracticeView) {
      state.selectedPractice = i;
    }
  },
  actions: {
    setSelectedPractice({ commit }, i: PracticeView) {
      commit('setSelectedPractice', i);
    }
  },
  getters: {
    getSelectedPractice: (state) => state.selectedPractice,
  }
}
export default practiceStoreModule;